import React from 'react';

import { Text } from '@/components/shared/element/text';
import { HeadingItem } from '@/components/shared/headline/heading-item';
import { Container } from '@/components/shared/layout/container';
import { Flex } from '@/components/shared/layout/flex';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { ImageProps } from '@/components/shared/media/image/Image.props';
import { styled } from '@/stitches.config';

const LineUpWrapper = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: '$space-6',
  marginTop: '$space-6',
  '@sm': {
    marginTop: '$space-10',
  },
  '@md': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  '@lg': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
});

const VehicleWrap = styled('div', {
  maxWidth: 236,
  width: '100%',
  mx: 'auto',
  textAlign: 'center',
});

interface IServiceLineUpVehicle {
  image: ImageProps;
  label: string;
}

export interface IServiceLineUpProps {
  title: string;
  items: IServiceLineUpVehicle[];
}

const View: React.FunctionComponent<IServiceLineUpProps> = (
  props: IServiceLineUpProps
) => {
  const { items } = props;
  return (
    <Section size="2xl" test="section_service_leasing_service_line-up">
      <Container>
        <HeadingItem title={props.title} size="sm" isCenter />
        <LineUpWrapper>
          {items?.map((vehicle, index) => (
            <VehicleWrap key={index}>
              {!!vehicle.image && (
                <Image
                  src={vehicle.image.src}
                  alt={vehicle.image.alt}
                  width={236}
                  height={160}
                  layout="responsive"
                  sources={[
                    { srcset: vehicle.image.src, options: { width: 256 } },
                  ]}
                />
              )}
              <Flex direction="column" alignItems="center">
                <Text
                  size="text-body-1"
                  font="bold"
                  variant="text-gray-dark"
                  dangerouslySetInnerHTML={{ __html: vehicle.label }}
                />
              </Flex>
            </VehicleWrap>
          ))}
        </LineUpWrapper>
      </Container>
    </Section>
  );
};

View.displayName = 'SectionServiceLeasingServiceLineUp';
export default View;
